import React from "react";
import { CircularProgress } from "@mui/material";
import { Navigate } from "react-router-dom";
import { useGetUsersListQuery } from "../apis/userDetailsAPi";
import { ROUTES } from "../consts/routes.consts";
import { isRestrictedAccessEmail } from "../consts/restricted-access.const";

export const ProtectedRestrictedAccessRoute = ({
  children,
  redirectTo = ROUTES.HOME,
}: {
  children: React.ReactNode;
  redirectTo?: string;
}) => {
  const { data: userData, isLoading } = useGetUsersListQuery<any>();
  const apiEmail = userData?.user?.email as string | undefined;
  const storageEmail = localStorage.getItem("userEmail") || undefined;
  const userEmail = apiEmail || storageEmail;

  if (isLoading) {
    return (
      <div className="fixed inset-0 z-[9999] min-h-screen flex items-center justify-center backdrop-blur-[20px] bg-[rgba(0,0,0,0.5)]">
        <CircularProgress size={50} style={{ color: "#ffffff" }} />
      </div>
    );
  }

  if (!isRestrictedAccessEmail(userEmail)) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return <>{children}</>;
};

export default ProtectedRestrictedAccessRoute;

